import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { lineItemSelector } from '../../../../../../../modules/selectors/lineItems'

const AgePreview = () => {
  const { t } = useTranslation()

  const { age } = useSelector(lineItemSelector)

  const formattedMaxAge = useMemo(() => (age.age_max === 65 ? `${age.age_max}+` : age.age_max), [age.age_max])

  return age ? <span>{`${age.age_min}-${formattedMaxAge} ${t('year olds')}`}</span> : null
}

export default AgePreview
